<template>
  <section class="classification py-5" v-if="studioCategories.length > 0">
    <div class="container">
      <div class="_title">
        <div class="label-div">
          <i class="mdi mdi-circle"></i>&nbsp;
          {{ $t('discover-sections') }}
        </div>
        <h1>{{ homeSetting.studios_categories_title }}</h1>
      </div>
      <div class="row mt-5" v-if="studioCategories.length > 0">
        <div style="direction: rtl;text-align: center;text-align: -webkit-center;width: auto;margin: 0 auto;">
          <carousel v-bind="options">
            <slide class="slide-item" v-for="catg in studioCategories" :key="catg.id">
              <a @click="openCategory(catg.id, homeSetting.if_show_categories_filter)">
                <div class="category_item">
                  <div class="card custom-section-div">
                    <img class="card-img" :src="catg.image_url" alt="classification"/>
                    <div class="card-img-overlay">
                      <p class="card-title">
                        {{ catg.name }}
                        <i class="mdi mdi-arrow-left"></i>
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </slide>
          </carousel>
        </div>
      </div>
      <div v-else class="row">
        <v-col cols="12" md="6">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="6">
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-col>
      </div>

      <v-dialog v-model="dialog" width="600px" class="modal_auth">
        <v-card class="dialog_auth" style="height: 500px;">
          <v-container class="px-8">
            <div class="text-end mb-8">
              <a href="javascript:void(0);" @click.prevent="dialog = false">
                <i class="mdi mdi-close mdi-18px"></i>
              </a>
            </div>
            <div class="filter_projects text-start">
              <template>
                <div class="d-flex justify-content-between mb-2">
                  <label>{{ $t('filterProject.city') }}</label>
                  <button @click="toggleCloseMenu" class="btn btn-dark px-8" v-if="chooseDoneShow">
                    <i class="mdi mdi-check-all"></i>&nbsp;&nbsp;{{ $t('choose-done') }}
                  </button>
                </div>
              </template>
              <v-select
                  :items="cities"
                  :item-text="(sec) => sec.name"
                  :item-value="(sec) => sec.id"
                  v-model="filter.citiesVal"
                  multiple filled solo :label="$t('filterProject.city')" prepend-inner-slot
                  :menu-props="{closeOnClick: closeOnClick,closeOnContentClick: closeOnClick}"
                  :no-data-text="$t('no-data')"
                  @click="chooseDoneShow = true;">
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggleCheckAll">
                    <v-list-item-action>
                      <v-icon>{{ icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('choose-all') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>

              <label class="mb-2">{{ $t('studios.StartDate') }}</label>
              <v-menu :close-on-content-click="true" :nudge-right="0" transition="scale-transition"
                      offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="filter.add_date" :placeholder="$t('choose-date')"
                                readonly filled solo v-bind="attrs"
                                v-on="on" style="border: none;">
                    <template #prepend-inner>
                      <v-icon color="#4D4D4D" style="margin-inline-end: 10px;">mdi-calendar</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker :locale="lang" v-model="filter.add_date"
                               :min="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                ></v-date-picker>
              </v-menu>

              <div class="text-center">
                <button @click="search" class="btn btn-dark mt-16 w-50">
                  {{ $t("filterProject.search") }}
                </button>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  props: ["studioCategories", "homeSetting"],
  data() {
    return {
      dialog: false,
      lang: localStorage.getItem('lang') || 'ar',
      cities: [],
      filter: {
        citiesVal: [],
        categoriesVal: [],
        add_date: '',
      },
      closeOnClick: false,
      chooseDoneShow: false,
      options: {
        loop: true,
        margin: 5,
        perPage: 1,
        center: false,
        autoplay: true,
        autoplayTimeout: 3000,
        paginationEnabled: false,
        autoplayHoverPause: true,
        navigationEnabled: true,
        paginationColor: "#555",
        paginationActiveColor: "#9f762b",
        paginationSize: 5,
        rtl: true,
        perPageCustom: [
          [0, 1],
          [475, 2],
          [768, 3],
          [1024, 4],
        ],
      },
    };
  },
  created() {
    axios.get("cities", {})
        .then(({data}) => {
          this.cities = data.data;
        });
  },
  computed: {
    checkAllCities() {
      return this.filter.citiesVal.length === this.cities.length
    },
    checkSomeCities() {
      return this.filter.citiesVal.length > 0 && !this.checkAllCities
    },
    icon() {
      if (this.checkAllCities) return 'mdi-close-box'
      if (this.checkSomeCities) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  methods: {
    openCategory(categoryId, ifShowCategoriesFilter) {
      this.filter.categoriesVal = [categoryId];
      this.dialog = (ifShowCategoriesFilter === 'yes');
      if (ifShowCategoriesFilter === 'no') {
        this.search();
      }
    },
    search() {
      this.$router.push({
        name: 'studios',
        query: this.filter
      });
    },
    toggleCheckAll() {
      this.$nextTick(() => {
        if (this.checkAllCities) {
          this.filter.citiesVal = [];
        } else {
          this.filter.citiesVal = this.cities.map(a => a.id);
        }
      })
    },
    toggleCloseMenu() {
      this.chooseDoneShow = false;
      this.closeOnClick = true;
      setTimeout(() => {
        this.closeOnClick = false;
      }, 100);
    }
  },
};
</script>

<style lang="scss" scoped>
.classification {
  margin: 60px 0;
  padding: 0 30px;
  @media(max-width: 580px) {
    padding: 0 0;
  }

  ._title {
    margin-bottom: 35px;

    h1 {
      color: #000;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 48px;
    }

    span {
      color: #4D4D4D;
      font-size: 23px;
      font-weight: 500;
    }
  }

  @media (max-width: 768px) {
    margin: 0;
    ._title {
      h1 {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }

  .custom-section-div {
    color: #fff;
    border: none;
    overflow: hidden;
    width: 300px;
    border-radius: 20px;
  }

  .custom-section-div:before {
    content: '';
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%);
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
  }

  .custom-section-div:hover:before {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%);
    transition: 300ms ease-in-out;
  }

  .VueCarousel-slide:nth-child(odd) .custom-section-div {
    width: 400px;
  }

  @media (max-width: 768px) {
    .custom-section-div {
      width: 275px;
    }

    .VueCarousel-slide:nth-child(odd) .custom-section-div {
      width: 275px;
    }
  }

  .custom-section-div .card-img {
    width: 300px;
    height: 300px;
    object-fit: cover;
  }

  .VueCarousel-slide:nth-child(odd) .custom-section-div .card-img {
    width: 400px;
    height: 400px;
  }

  .custom-section-div .card-img-overlay {
    top: unset;
    z-index: 9;
    text-align: end;
    bottom: 8px;
  }

  .custom-section-div .card-img-overlay p {
    font-size: 14px;
    text-wrap: nowrap;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.50);
    background: rgba(255, 255, 255, 0.20);
    backdrop-filter: blur(9px);
    color: #FFF;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    display: inline;
    padding: 8px 16px;
  }

  .category_item {
    margin: 15px 7px 0;
  }
}
</style>
<style>
.classification .VueCarousel-inner {
  align-items: center;
}

.classification .VueCarousel-navigation-next {
  right: calc(50% + 2px) !important;
}

.classification .VueCarousel-navigation-prev {
  left: calc(50% + 2px) !important;
}
</style>
